var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sidebar-param-clinique"},[_c('h1',[_vm._v("sidebar-param-clinique Component")])])
}]

export { render, staticRenderFns }